/**
 * Table sort component
 * - not in the general component dir since its not really useful anywhere else
 */
import React from 'react';

import cx from 'classnames';

interface SortProps {
  enabled: boolean;
  descending: boolean;
}
export const Sort = ({ enabled, descending }: SortProps) => {
  if (!enabled) return <></>;
  return (
    <div className={'arrow-wrapper'}>
      <svg
        className={cx('arrow', descending && 'arrow-descending')}
        viewBox={'0 0 24 24'}
        width={'14'}
        height={'14'}
        stroke={'currentColor'}
        strokeWidth={'1.5'}
        fill={'none'}
        shapeRendering={'geometricPrecision'}
      >
        <path d={'M12 19V5'} />
        <path d={'M5 12l7-7 7 7'} />
      </svg>
    </div>
  );
};
